export const CARD_STYLE = {
  borderRadius: '20px',
  backgroundColor: '#ffffff',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  padding: '16px 16px 12px 16px',
  cursor: 'text',
  display: 'flex',
  flexDirection: 'column',
};

export const CARD_STATE_STYLES = {
  focused: {
    border: '1px solid #303453',
    boxShadow: '0 0 0 3px rgba(48, 52, 83, 0.12), 0 10px 30px rgba(0, 0, 0, 0.08)',
  },
  idle: {
    border: '1px solid #e2e8f0',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
  },
};

export const TEXTAREA_STYLE = {
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
  backgroundImage: 'none',
  backgroundColor: 'transparent',
  fontSize: '14px',
  lineHeight: '1.6',
  resize: 'none',
  color: '#1a202c',
  width: '100%',
  padding: '0',
  minHeight: '64px',
};

export const ATTACH_BUTTON_STYLE = {
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  border: '1px solid #e2e8f0',
  flexShrink: 0,
};

export const SEND_BUTTON_STYLE = {
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  padding: 0,
  margin: 0,
  flexShrink: 0,
};

export const BUTTON_STYLE = {
  height: '36px',
  borderRadius: '8px',
  padding: '0 16px',
  margin: 0,
  fontSize: '13px',
  fontWeight: 600,
  textTransform: 'none',
  letterSpacing: '0.2px',
  flexShrink: 0,
};

export const PLACEHOLDER = 'Describe what to build or fix...';
